import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/organization/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/organization/$id/"!</div>
}
